import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../ChallengeAdmin'

import YumField from '../../../../components/YumInput/YumInput'

import { ReactComponent as TitleActiveIcon } from '../../../../assets/v3/icons/title-active.svg'
import { ReactComponent as TitleInactiveIcon } from '../../../../assets/v3/icons/title-inactive.svg'
import { ReactComponent as PrizeActiveIcon } from '../../../../assets/v3/icons/prize-active.svg'
import { ReactComponent as PrizeInactiveIcon } from '../../../../assets/v3/icons/prize-inactive.svg'
import { ReactComponent as DescriptionActiveIcon } from '../../../../assets/v3/icons/description-active.svg'
import { ReactComponent as DescriptionInactiveIcon } from '../../../../assets/v3/icons/description-inactive.svg'

interface ChallengeStepPeriodProps {
  control: Control<FormData>
  errors: FieldErrors<FormData>
  formStep: number
}

export default function ChallengeStepDetails(props: ChallengeStepPeriodProps) {
  const { control, errors, formStep } = props

  const challengeNameField = (
    <Controller
      name="title"
      rules={{ required: formStep === 5 }}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Challenge name (required)`}
          error={!!errors.title}
          startIcon={TitleActiveIcon}
          startIconInactive={TitleInactiveIcon}
          {...otherField}
          inputProps={{
            autoComplete: 'off',
          }}
        />
      )}
    />
  )

  const prizeField = (
    <Controller
      name="prize"
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Prize`}
          error={!!errors.prize}
          startIcon={PrizeActiveIcon}
          startIconInactive={PrizeInactiveIcon}
          {...otherField}
        />
      )}
    />
  )

  const descriptionField = (
    <Controller
      name="description"
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Description`}
          error={!!errors.description}
          startIcon={DescriptionActiveIcon}
          startIconInactive={DescriptionInactiveIcon}
          multiline
          minRows={2}
          {...otherField}
        />
      )}
    />
  )

  return (
    <>
      {challengeNameField}
      {prizeField}
      {descriptionField}
    </>
  )
}
